import * as React from 'react';
import { IPKKObjectSearchResult } from 'services/search/search-reducer';

interface IPkkResultItem {
    item: IPKKObjectSearchResult,
    onClick: (item: IPKKObjectSearchResult) => void
}

export const PkkResultItem: React.FC<IPkkResultItem> = (props) => {
    const { item, onClick } = props;

    const onItemClick = () => {
        onClick(item);
    };

    return (
        <div className="pkk-search-item" onClick={onItemClick}>
            <div className="pkk-search-name">{item.name}</div>
        </div>
    );
};
